<template>
  <input
    :type="type"
    :data-lpignore="ignoreLastPass"
    class="hl-text-input shadow-sm focus:ring-curious-blue-500 focus:border-curious-blue-500 block w-full sm:text-sm border-gray-300 rounded disabled:opacity-50 text-gray-800"
    :class="customClass"
    :value="modelValue"
    :disabled="disabled"
    @input="(e: Event) => $emit('update:modelValue', (e.target as HTMLInputElement)?.value)"
    @keyup="(e: Event) => $emit('keyup', (e.target as HTMLInputElement)?.value)"
    @keydown="(e: Event) => $emit('keydown', e)"
    @change="(e: Event) => $emit('change', (e.target as HTMLInputElement)?.value)"
    @blur="(e: Event) => $emit('blur', (e.target as HTMLInputElement)?.value)"
    @focus="(e: Event) => $emit('focus', (e.target as HTMLInputElement)?.value)"
    @keyup.enter="(e: Event) => $emit('enter', (e.target as HTMLInputElement)?.value)"
    :min="min"
    :max="max"
    :autocomplete="autocomplete"
    :placeholder="placeholder"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  emits: {
    'update:modelValue': (value: string | number | boolean) => true,
    'keyup': (value: string) => true,
    'keydown': (event: Event) => true,
    'change': (value: string) => true,
    'blur': (value: string) => true,
    'focus': (value: string) => true,
    'enter': (value: string) => true
  },
  $_veeValidate: {
    value() {
      return this.modelValue;
    }
  },
  props:{
    modelValue: {
      type: [String, Number, Boolean],
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    customClass: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    min: {
      type: [Number, String]
    },
    max: {
      type: [Number, String]
    },
    autocomplete: {
      type: String,
      default: ''
    },
    ignoreLastPass:{
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: ''
    }
  }
})
</script>

<style >
.hl-text-area-input::placeholder,
.hl-text-input::placeholder {
  color: rgb(175, 184, 188);
  opacity: 1;
}
</style>
